import { User } from './user';
export class UserIndicateds {
  companyIndicated = 0;
  indicated = 0;
  indicatedCompanies: User[];
  indicatedUsers: User[];
  primeNetworkMembers = 0;
}
